import React, { useCallback, useEffect, useMemo, useState } from "react";
import { VscSaveAs } from "react-icons/vsc";
import Select from "react-select";
import Normal from "../../common/questionType/Normal";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  addQuestion,
  editQuestion,
  getQuestionById,
} from "../../redux/services/questionSlice";
import { useUser } from "../../redux/services/authSlice";
import { getsubTopicData } from "../../redux/services/subTopicSlice";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import RadioButtons from "../../common/RadioButton";
import { getFullLengthById } from "../../redux/services/subjectSlice";

const QuestionFormPage = ({ isAdd }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const questionId = queryParams.get("questionId");
  const subjectId = queryParams.get("subjectId");
  const { user } = useUser();
  const storedDetails = useMemo(() => {
    return JSON.parse(localStorage.getItem("subjectDetails"));
  }, []);
  // console.log('storedDetails', storedDetails)
  const subTopicData = useSelector((state) => state?.subTopic?.subTopicData);
  const fullLengthData = useSelector((state) => state?.subject?.fullLengthData);
  const questionByIdData = useSelector(
    (state) => state?.question?.getQuestionData
  );
  const subTopicIds = subTopicData?.[0]?.subTopicIds;
  const radioOptions = [
    { label: "concept", value: "concept" },
    { label: "aptitude", value: "aptitude" },
    { label: "random", value: "random" },
  ];

  const questionTypeOption = [
    { label: "normal", value: "normal" },
    { label: "statement", value: "statement" },
    { label: "pair", value: "pair" },
    { label: "Normal-Csat", value: "normal-csat" },
    { label: "Statement-Csat", value: "statement-csat" },
  ];
  const handleQuestionById = useCallback(
    async (itemId) => {
      try {
        await dispatch(getQuestionById(itemId));
      } catch (error) {}
    },
    [dispatch]
  );
  useEffect(() => {
    if (questionId) {
      handleQuestionById(questionId);
    }
  }, [questionId, handleQuestionById]);
  const getAllFullLengthData = useCallback(async () => {
    try {
      await dispatch(
        getFullLengthById({
          isFullLength: storedDetails.isFullLength,
        })
      );
    } catch (error) {}
  }, [dispatch, storedDetails]);

  useEffect(() => {
    if ((storedDetails.isFullLength === true || storedDetails.isSubjectShow === true)) {
      getAllFullLengthData();
    }
  }, [storedDetails, getAllFullLengthData]);

  const fetchSubTopic = useCallback(async () => {
    let payload = subjectId ? subjectId : questionByIdData?.subjectId;
    try {
      await dispatch(getsubTopicData(payload));
    } catch (error) {}
  }, [dispatch, subjectId, questionByIdData?.subjectId]);

  useEffect(() => {
    if (subjectId || questionByIdData?.subjectId) {
      fetchSubTopic();
    }
  }, [subjectId, questionByIdData?.subjectId, fetchSubTopic]);

  const initialValues = {
    subject: subjectId || questionByIdData?.subjectId || "",
    subtopic: "",
    categoryType: "concept",
    questionType: "normal",
    englishQuestion: {
      question: "",
      options: { A: "", B: "", C: "", D: "" },
      answer: "",
      solution: "",
      statements: [],
      pairs: [],
      lastQuestion: "",
    },
    hindiQuestion: {
      question: "",
      options: { A: "", B: "", C: "", D: "" },
      answer: "",
      solution: "",
      statements: [],
      pairs: [],
      lastQuestion: "",
    },
    ...((storedDetails.isFullLength ||storedDetails.isSubjectShow) && { isFullLength: "" }),
  };

  const validationSchema = Yup.object().shape({
    subject: Yup.string().required("Subject is required"),
    subtopic: Yup.string().required("SubTopic is required"),
    categoryType: Yup.string().required("Category type is required"),
    questionType: Yup.string().required("Question type is required"),
    ...((storedDetails.isFullLength|| storedDetails.isSubjectShow) && {
      isFullLength: Yup.string().required("Full Length is required"),
    }),
    englishQuestion: Yup.object().shape({
      question: Yup.string().required("Question is required"),
      options: Yup.object().shape({
        A: Yup.string().required("Option A is required"),
        B: Yup.string().required("Option B is required"),
        C: Yup.string().required("Option C is required"),
        D: Yup.string().required("Option D is required"),
      }),
      answer: Yup.string().required("Answer is required"),
      solution: Yup.string().required("Solution is required"),
      statements: Yup.array().when("$questionType", {
        is: (val) => val === "statement" || val === "statement-csat",
        then: Yup.array()
          .of(Yup.string().required("Statement cannot be empty"))
          .min(1, "At least one statement is required"),
        otherwise: Yup.array().notRequired(),
      }),
      pairs: Yup.array().when("$questionType", {
        is: "pair",
        then: Yup.array()
          .of(
            Yup.object().test(
              "dynamic-pairs",
              "All pair fields must be filled",
              (obj) => {
                if (!obj || typeof obj !== "object") return false;
                return Object.values(obj).every(
                  (value) => typeof value === "string" && value.trim() !== ""
                );
              }
            )
          )
          .min(1, "At least one pair is required"),
        otherwise: Yup.array().notRequired(),
      }),
      lastQuestion: Yup.string().when("$questionType", {
        is: (val) => val === "statement" || val === "pair" || val === "statement-csat",
        then: Yup.string().required(
          "Last question is required for statement or pair type"
        ),
        otherwise: Yup.string().notRequired(),
      }),
    }),

    hindiQuestion: Yup.object().shape({
      question: Yup.string().required("Question is required"),
      options: Yup.object().shape({
        A: Yup.string().required("Option A is required"),
        B: Yup.string().required("Option B is required"),
        C: Yup.string().required("Option C is required"),
        D: Yup.string().required("Option D is required"),
      }),
      answer: Yup.string().required("Answer is required"),
      solution: Yup.string().required("Solution is required"),
      statements: Yup.array().when("$questionType", {
        is: (val) => val === "statement" || val === "statement-csat",
        then: Yup.array()
          .of(Yup.string().required("Statement cannot be empty"))
          .min(1, "At least one statement is required"),
        otherwise: Yup.array().notRequired(),
      }),
      pairs: Yup.array().when("$questionType", {
        is: "pair",
        then: Yup.array()
          .of(
            Yup.object().test(
              "dynamic-pairs",
              "All pair fields must be filled",
              (obj) => {
                if (!obj || typeof obj !== "object") return false;
                return Object.values(obj).every(
                  (value) => typeof value === "string" && value.trim() !== ""
                );
              }
            )
          )
          .min(1, "At least one pair is required"),
        otherwise: Yup.array().notRequired(),
      }),
      lastQuestion: Yup.string().when("$questionType", {
        is: (val) => val === "statement" || val === "pair" || val === "statement-csat",
        then: Yup.string().required(
          "Last question is required for statement or pair type"
        ),
        otherwise: Yup.string().notRequired(),
      }),
    }),
  });
  const onSubmit = async (values) => {
    setLoading(true);
    try {
      let payload = {
        subjectId: subjectId || questionByIdData?.subjectId,
        classesId: user?._id,
        subtopicId: values.subtopic,
        type: values?.categoryType,
        questionType: values?.questionType,
        ...((storedDetails.isFullLength|| storedDetails.isSubjectShow) && {
          fullLengthSubjectId: values.isFullLength,
        }),
        englishQuestion: {
          question: values.englishQuestion?.question,
          options: values?.englishQuestion?.options,
          answer: values?.englishQuestion?.answer,
          solution: values?.englishQuestion?.solution,
          ...((values?.questionType === "statement" || values?.questionType === "statement-csat") && {
            statementQuestion: values?.englishQuestion?.statements?.map(
              (statement) => ({
                combined: statement,
              })
            ),
          }),
          ...(values?.questionType === "pair" && {
            pairQuestion: Array.isArray(values?.englishQuestion?.pairs)
              ? values?.englishQuestion?.pairs?.map((pair) => {
                  const combinedValue = Object.values(pair).join(" --- ");
                  return { combined: combinedValue };
                }) || []
              : [],
          }),
          ...((values?.questionType === "statement" ||
            values?.questionType === "pair" || values?.questionType === "statement-csat") && {
            lastQuestion: values?.englishQuestion?.lastQuestion || "",
          }),
        },
        hindiQuestion: {
          question: values.hindiQuestion?.question,
          options: values?.hindiQuestion?.options,
          answer: values?.hindiQuestion?.answer,
          solution: values?.hindiQuestion?.solution,
          ...((values?.questionType === "statement" || values?.questionType === "statement-csat") && {
            statementQuestion: values?.hindiQuestion?.statements?.map(
              (statement) => ({
                combined: statement,
              })
            ),
          }),
          ...(values?.questionType === "pair" && {
            pairQuestion: Array.isArray(values?.hindiQuestion?.pairs)
              ? values?.hindiQuestion?.pairs?.map((pair) => {
                  const combinedValue = Object.values(pair).join(" --- ");

                  return { combined: combinedValue };
                }) || []
              : [],
          }),

          ...((values?.questionType === "statement" ||
            values?.questionType === "pair" || values?.questionType === "statement-csat") && {
            lastQuestion: values?.hindiQuestion?.lastQuestion || "",
          }),
        },
        ...(questionId && { questionId: questionId }),
      };
      if (isValid) {
      } else {
        toast("Form is invalid. Fix errors first.", {
          autoClose: 2000,
          pauseOnHover: false,
        });
      }
      // console.log("payload",payload);
      if (questionId) {
        const response = await dispatch(editQuestion(payload));
        if (response?.payload?.status === 200) {
          toast(response?.payload?.message, {
            autoClose: 2000,
            pauseOnHover: false,
          });
          setLoading(false);
          navigate(`/subjectDetails?subjectId=${questionByIdData?.subjectId}`);
        }
      } else {
        const response = await dispatch(addQuestion(payload));
        if (response?.payload?.status === 200) {
          toast(response?.payload?.message, {
            autoClose: 2000,
            pauseOnHover: false,
          });
          navigate(`/subjectDetails?subjectId=${subjectId}`);
        }
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const {
    values,
    handleSubmit,
    setFieldValue,
    handleChange,
    errors,
    touched,
    isValid,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  useEffect(() => {
    if (subjectId) {
      if (values.questionType === "statement" || values.questionType === "statement-csat") {
        setFieldValue("englishQuestion.statements", [""]);
        setFieldValue("hindiQuestion.statements", [""]);
      } else {
        setFieldValue("englishQuestion.statements", []);
        setFieldValue("hindiQuestion.statements", []);
      }

      if (values.questionType === "pair") {
        setFieldValue("englishQuestion.pairs", [{ pair1: "", pair2: "" }]);
        setFieldValue("hindiQuestion.pairs", [{ pair1: "", pair2: "" }]);
      } else {
        setFieldValue("englishQuestion.pairs", []);
        setFieldValue("hindiQuestion.pairs", []);
      }
    }
  }, [values.questionType, subjectId, setFieldValue]);

  const sharedAnswerHandler = (value) => {
    setFieldValue("englishQuestion.answer", value);
    setFieldValue("hindiQuestion.answer", value);
  };
  const addStatementInOtherForm = (languagePrefix) => {
    if (languagePrefix === "englishQuestion") {
      setFieldValue("hindiQuestion.statements", [
        ...values.hindiQuestion.statements,
        "",
      ]);
    } else if (languagePrefix === "hindiQuestion") {
      setFieldValue("englishQuestion.statements", [
        ...values.englishQuestion.statements,
        "",
      ]);
    }
  };
  const removeStatementInOtherForm = (languagePrefix, index) => {
    if (languagePrefix === "englishQuestion") {
      const updatedStatements = values.hindiQuestion.statements.filter(
        (_, idx) => idx !== index
      );
      setFieldValue("hindiQuestion.statements", updatedStatements);
    } else if (languagePrefix === "hindiQuestion") {
      const updatedStatements = values.englishQuestion.statements.filter(
        (_, idx) => idx !== index
      );
      setFieldValue("englishQuestion.statements", updatedStatements);
    }
  };
  useEffect(() => {
    if (questionId) {
      const englishStatements =
        questionByIdData?.englishQuestion?.statementQuestion?.map(
          (item) => item.combined
        ) || [];
      const hindiStatements =
        questionByIdData?.hindiQuestion?.statementQuestion?.map(
          (item) => item.combined
        ) || [];
      const englishPairs =
        questionByIdData?.englishQuestion?.pairQuestion?.map((item) => {
          const pairParts = item.combined.split(" --- ");
          const pairs = {};
          pairParts.forEach((pair, index) => {
            pairs[`pair${index + 1}`] = pair.trim();
          });
          return pairs;
        }) || [];
      const hindiPairs =
        questionByIdData?.hindiQuestion?.pairQuestion?.map((item) => {
          const pairParts = item.combined.split(" --- ");
          const pairs = {};
          pairParts.forEach((pair, index) => {
            pairs[`pair${index + 1}`] = pair.trim();
          });
          return pairs;
        }) || [];
      const data = {
        subject: questionByIdData?.subjectId,
        subtopic: questionByIdData?.subtopicId?._id,
        categoryType: questionByIdData?.type,
        questionType: questionByIdData?.questionType,
        isFullLength: questionByIdData?.fullLengthSubjectId,
        englishQuestion: {
          question: questionByIdData?.englishQuestion?.question || "",
          options: questionByIdData?.englishQuestion?.options || {
            A: "",
            B: "",
            C: "",
            D: "",
          },
          answer: questionByIdData?.englishQuestion?.answer || "",
          solution: questionByIdData?.englishQuestion?.solution || "",
          statements: englishStatements,
          pairs: englishPairs,
          lastQuestion: questionByIdData?.englishQuestion?.lastQuestion || "",
        },
        hindiQuestion: {
          question: questionByIdData?.hindiQuestion?.question || "",
          options: questionByIdData?.hindiQuestion?.options || {
            A: "",
            B: "",
            C: "",
            D: "",
          },
          answer: questionByIdData?.hindiQuestion?.answer || "",
          solution: questionByIdData?.hindiQuestion?.solution || "",
          statements: hindiStatements,
          pairs: hindiPairs,
          lastQuestion: questionByIdData?.hindiQuestion?.lastQuestion || "",
        },
      };
      setValues({ ...data });
    }
  }, [questionId, questionByIdData, setValues]);
  const disableFields = {
    statement: questionId && values.questionType !== "statement",
    pair: questionId && values.questionType !== "pair",
    normal: questionId && values.questionType !== "normal",
    "normal-csat": questionId && values.questionType !== "normal-csat",
    "statement-csat": questionId && values.questionType !== "statement-csat",
  };
  return (
    <div>
      <section className="bg-white rounded-lg border-2 border-slate-300 font-sans duration-300 ease-in-out md:m-4 m-2">
        <div className="py-8 px-4 space-y-4 lg:px-6">
          <div className="">
            <p className="md:text-3xl text-2xl tracking-tight font-semibold text-gray-900 capitalize">
              {isAdd} Question
            </p>
            <p className="md:text-xl text-base mt-2 tracking-tight font-medium text-left text-slate-600">
              Fill in the details below to create a new question.
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 overflow-none">
              <div className="space-y-2 w-full">
                <label className="font-medium text-gray-900 text-start capitalize text-md">
                  Subject
                </label>
                <input
                  className="border-2 pl-4 border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed transition-colors rounded-md w-full py-2 px-3 leading-tight focus:outline-none mt-3"
                  type="text"
                  name="subjectId"
                  onChange={handleChange}
                  value={storedDetails.name || ""}
                  disabled
                />
                {errors.subject && touched.subject && (
                  <div className="text-red-600 text-sm">{errors.subject}</div>
                )}
              </div>

              <div className="space-y-2 w-full">
                <label className="font-medium text-gray-900 text-start capitalize text-md">
                  Subtopic
                </label>
                <Select
                  options={subTopicIds?.map((sub) => ({
                    value: sub._id,
                    label: sub.name,
                  }))}
                  onChange={(selectedOption) => {
                    setFieldValue(
                      "subtopic",
                      selectedOption ? selectedOption.value : ""
                    );
                  }}
                  value={
                    subTopicIds?.find((item) => item._id === values.subtopic)
                      ? {
                          value: values.subtopic,
                          label: subTopicIds.find(
                            (item) => item._id === values.subtopic
                          )?.name,
                        }
                      : null
                  }
                  placeholder="Select subtopic"
                />
                {errors.subtopic && touched.subtopic && (
                  <div className="text-red-600 text-sm">{errors.subtopic}</div>
                )}
              </div>
              {(storedDetails.isFullLength === true || storedDetails.isSubjectShow === true) && (
                <div className="space-y-2 w-full">
                  <label className="font-medium text-gray-900 text-start capitalize text-md">
                    UPSC Original Subject
                  </label>
                  <Select
                    options={fullLengthData?.map((sub) => ({
                      value: sub._id,
                      label: sub.name,
                    }))}
                    onChange={(selectedOption) => {
                      setFieldValue(
                        "isFullLength",
                        selectedOption ? selectedOption.value : ""
                      );
                    }}
                    value={
                      fullLengthData?.find(
                        (item) => item._id === values.isFullLength
                      )
                        ? {
                            value: values.isFullLength,
                            label: fullLengthData.find(
                              (item) => item._id === values.isFullLength
                            )?.name,
                          }
                        : null
                    }
                    placeholder="Select UPSC Original Subject"
                  />
                  {errors.isFullLength && touched.isFullLength && (
                    <div className="text-red-600 text-sm">
                      {errors.isFullLength}
                    </div>
                  )}
                </div>
              )}

              <div className="space-y-3 w-full">
                <label className="font-medium text-gray-900 text-start capitalize text-md">
                  Category Type
                </label>
                <RadioButtons
                  radioName={"categoryType"}
                  options={radioOptions}
                  checkedValue={values?.categoryType}
                  onHandleChange={(e) =>
                    setFieldValue("categoryType", e.target.value)
                  }
                />
                {errors.categoryType && touched.categoryType && (
                  <div className="text-red-600 text-sm">
                    {errors.categoryType}
                  </div>
                )}
              </div>
            </div>
            <div className="space-y-3 w-full my-5">
              <p className="flex items-center capitalize text-xl font-medium text-gray-900">
                Question Type:
              </p>
              <RadioButtons
                radioName="questionType"
                options={questionTypeOption}
                checkedValue={values?.questionType}
                onHandleChange={(e) =>
                  setFieldValue("questionType", e.target.value)
                }
                disableFields={disableFields}
              />
            </div>
            {values.questionType ? (
              <Normal
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                handleBlur={handleBlur}
                sharedAnswerHandler={sharedAnswerHandler}
                addStatementInOtherForm={addStatementInOtherForm}
                removeStatementInOtherForm={removeStatementInOtherForm}
              />
            ) : (
              ""
            )}
            <div className="mt-6 flex justify-center">
              {loading ? (
                <button className="flex justify-center items-center w-[250px] h-[50px] bg-[#124699] text-white rounded-lg hover:bg-[#124699]">
                  <div className="loader"></div>
                </button>
              ) : (
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="flex justify-center items-center w-[250px] h-[50px] bg-[#124699] font-semibold text-white rounded-lg hover:bg-[#124699]"
                >
                  <VscSaveAs className="mr-2" />
                  Save Question
                </button>
              )}
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default QuestionFormPage;
